<template>
  <div>
    <el-row class="headlogo" v-if="this.$root.HEADLOGO && !show">
      <el-col :span="24" class="logo"
        ><img :src="logo()" alt="JustTool"
      /></el-col>
    </el-row>
    <el-row class="container" v-else-if="ispc">
      <el-col :span="3" class="logo">
        <img :src="logo()" />
        <!-- <img :src="welogo" alt="JustTool" v-else /> -->
      </el-col>
      <el-col :span="16" v-if="show">
        <div class="menu" v-if="menusshow">
          <div
            v-for="(item, index) in menuItems()"
            :key="index"
            class="menu-item"
          >
            <a
              href="#"
              :class="{ active: isActive[index] }"
              @click.prevent="() => handleClick(item.pageId)"
              >{{ changeLan(item.pageTitle, item.pageId) }}</a
            >
          </div>
        </div>
        <div v-else class="menu settitle">
          {{ pageTitle }}
        </div>
      </el-col>
      <el-col :span="16" class="domainname" v-else>
        <div>{{ domainName() }}</div>
      </el-col>
      <el-col :span="5" class="user-info" v-if="show">
        <div class="game-name">{{ gameName() }}</div>
        <div class="team-name">{{ teamName() }}</div>
        <!-- <div class="logout" @click="() => this.logout()">
          {{ $t('header.BTN_LOGOUT') }}
        </div> -->
        <el-dropdown @command="handleCommand" trigger="click">
          <span class="el-dropdown-link">
            {{ $t('header.BTN_MENU')
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1" v-if="isOrginPassword">{{
              $t('header.BTN_HOME')
            }}</el-dropdown-item>
            <el-dropdown-item command="2" v-if="allowUpdatePassword">{{
              $t('header.BTN_UPDATEPASSWORD')
            }}</el-dropdown-item>
            <el-dropdown-item command="3">{{
              $t('header.BTN_LOGOUT')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <!-- <el-col :span="6" class="logo welogo" v-else-if="islogo">
      <img :src="welogo" alt="JustTool" />
    </el-col> -->
    </el-row>
    <div class="container" v-else>
      <div class="logo logos" v-if="!show">
        <img :src="logo()" alt="JustTool" />
        <!-- <img :src="welogo" alt="JustTool" v-else /> -->
        <div class="domainnameM">{{ domainName() }}</div>
      </div>
      <div class="useinfo" v-if="show">
        <div class="gamename">{{ gameName() }}</div>
        <!-- <div class="teamname">{{ teamName() }}</div>
      <div class="logoutm" @click="() => this.logout()">
        {{ $t('header.BTN_LOGOUT') }}
      </div> -->
        <div class="pageinfo">
          <div class="pagetitle" @click="drawer = true" v-if="menusshow">
            {{ pageTitle
            }}<i class="el-icon-arrow-down" style="margin-left: 5px"></i>
          </div>
          <div class="pagetitle" v-else>{{ pageTitle }}</div>
          <div class="menus">
            <p>{{ teamName() }}</p>
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="el-dropdown-link-m">
                {{ $t('header.BTN_MENU')
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1" v-if="isOrginPassword">{{
                  $t('header.BTN_HOME')
                }}</el-dropdown-item>
                <el-dropdown-item command="2" v-if="allowUpdatePassword">{{
                  $t('header.BTN_UPDATEPASSWORD')
                }}</el-dropdown-item>
                <el-dropdown-item command="3">{{
                  $t('header.BTN_LOGOUT')
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="menus">
            <b>{{ teamName() }}</b>
            <span @click="() => this.logout()">
              <i class="el-icon-switch-button"></i>
            </span>
            <el-dropdown @command="handleCommand" trigger="click">
              <span class="el-dropdown-link">
                <b>{{ teamName() }}</b
                ><i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <p style="padding: 5px; font-size: 14px; text-align: center">
                  {{ teamName() }}
                </p>
                <el-dropdown-item command="3">{{
                  $t('header.BTN_LOGOUT')
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
        </div>
      </div>
    </div>
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="50%"
    >
      <ul class="menu-item-phone">
        <li v-for="(item, index) in menuItems()" :key="index">
          <a
            href="#"
            :class="{ active: isActive[index] }"
            @click.prevent="() => handleClick(item.pageId)"
            >{{ item.pageTitle }}</a
          >
        </li>
      </ul>
    </el-drawer>
  </div>
</template>
<script>
import _ from 'lodash'
import logo from '../../assets/logo.jpg'
import UserModel from '../../models/user'
import * as storage from '../../utils/storage'
import * as constants from '../../constants'

export default {
  name: 'jtHeader',
  data() {
    return {
      welogo: logo,
      show: false,
      isActive: [],
      ispc: window.innerWidth > 768,
      pageTitle: '',
      islogo: false,
      menusshow: true,
      drawer: false,
    }
  },
  computed: {
    isOrginPassword() {
      let isToChangePassword = storage.getItem('orginPassword') == 1
      return !isToChangePassword
    },
    allowUpdatePassword() {
      const { gameData } = storage.getItem(constants.GLOBAL_CONFIG)
      return !gameData['不需邮箱']
    },
  },
  methods: {
    changeLan(label, pageId) {
      if (pageId == 9999 && storage.getItem(constants.LANGUAGE) === '中英文') {
        return '信息汇总与提交/Summary and Submit'
      } else {
        return label
      }
    },
    gameName() {
      const { gameName } = storage.getItem(constants.GLOBAL_CONFIG)
      return gameName
    },
    teamName() {
      const { teamName } = storage.getItem(constants.GLOBAL_CONFIG)
      return teamName
    },
    menuItems() {
      let pageInfo = null
      if (storage.getItem(constants.GLOBAL_CONFIG)) {
        pageInfo = storage.getItem(constants.GLOBAL_CONFIG).pageInfo
      }
      return pageInfo
    },

    // handleClick(pageId) {
    //   if (pageId == 9999) {
    //     window.open('https://www.jt-games.com/')
    //   } else {
    //     setTimeout(() => {
    //       const router = this.$router
    //       router.push({
    //         path: `/${pageId}.html`,
    //       })
    //     }, 300)
    //   }
    // },

    handleMenu() {
      this.drawer = true
    },

    domainName() {
      let data = this.$root.DOMAINNAME
      let router = this.$router
      let { current } = router.history
      if (current.path === '/updatepassword.html') {
        data = this.$t('jtPasswordForm.TITLE')
      }
      return data
    },

    logo() {
      let logopicture = null
      if (storage.getItem(constants.LOGO)) {
        if (storage.getItem(constants.LOGO) !== 1) {
          logopicture =
            'data:image/png;base64,' + storage.getItem(constants.LOGO)
          this.islogo = true
        } else {
          logopicture = logo
          this.islogo = false
        }
      } else {
        // logopicture = logo
        this.islogo = false
      }

      return logopicture
    },

    showMenuAndUserInfo() {
      const router = this.$router
      const path = router.history.current.path
      const isLoginOrRegister =
        _.startsWith(path, '/login.html') ||
        _.startsWith(path, '/signup.html') ||
        _.startsWith(path, '/wxlogin.html')
      const isLoggedIn = storage.getItem(constants.GLOBAL_CONFIG) != null
      return !isLoginOrRegister && isLoggedIn
    },

    isMenu() {
      const router = this.$router
      const path = router.history.current.path
      const isupdatepassword = _.startsWith(path, '/updatepassword')
      if (isupdatepassword) {
        this.pageTitle = this.$t('header.BTN_UPDATEPASSWORD')
      }
      this.menusshow = !isupdatepassword
    },

    handleCommand(command) {
      const router = this.$router
      switch (command) {
        case '1':
          router.push(`/page/1`)
          break
        case '2':
          router.push(`/updatepassword.html`)
          break
        case '3':
          this.logout()
          break
        default:
          break
      }
    },
    async logout() {
      await UserModel.logout()
      let msg = this.$t('header.TIPS_LOGOUT')
      let title = this.$t('global.TIPS')
      this.$alert(msg, title, {
        confirmButtonText: this.$t('page.SUBMIT_CONFIRM_OK'),
        callback: (action) => {
          const info = storage.getItem(constants.WX_INFO)
          const router = this.$router
          if (info) {
            storage.setItem(constants.GLOBAL_CONFIG, null)
            storage.clear('COZEID')
            window.location.href = '/wxlogin.html'
          } else {
            let logo = storage.getItem(constants.LOGO)
            storage.clear()
            if (logo !== -1) {
              storage.setItem(constants.LOGO, logo)
            }
            window.location.href = '/login.html'
          }
        },
      })
    },
    async updateaName() {
      const { teamId, teamName } = storage.getItem(constants.GLOBAL_CONFIG)
      await this.$prompt('', '修改队伍名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: teamName,
        closeOnClickModal: false,
        inputValidator: (value) => {
          if (_.isEmpty(_.trim(value))) {
            return '请输入新的队伍名！'
          }
        },
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            if (instance.inputValue === teamName) {
              done()
            } else {
              instance.confirmButtonLoading = true
              instance.confirmButtonText = '提交中...'
              let res = await UserModel.updateaName(teamId, instance.inputValue)
              if (res) {
                instance.confirmButtonLoading = false
                done()
              }
            }
          } else {
            done()
          }
        },
      }).then(({ value }) => {})
    },
    handleClick(pageId) {
      setTimeout(() => {
        this.$router.push(`/page/${pageId}`)
        if (this.drawer) {
          this.drawer = false
        }
      }, 300)
    },
    _init() {
      this.show = this.showMenuAndUserInfo()
      this.isMenu()
      const router = this.$router
      const path = router.history.current.path
      if (this.menuItems()) {
        this.isActive = _.map(this.menuItems(), (item) => {
          return path === `/page/${item.pageId}`
        })
        let data = this.menuItems().find(
          (item) => path === `/page/${item.pageId}`
        )
        if (data) {
          this.pageTitle = data.pageTitle
        }
      } else {
        this.pageTitle = null
      }
      const languageConfig = storage.getItem(constants.LANGUAGE)
      if (languageConfig) {
        const lang = {
          中文: 'zh',
          英文: 'en',
          中英文: 'enAndzh',
        }
        const language = languageConfig
        this.$i18n.locale = lang[language]
        this.$i18n.fallbackLocale = lang[language]
      } else {
        this.$i18n.locale = process.env.VUE_APP_I18N_LOCALE || 'zh'
        this.$i18n.fallbackLocale = process.env.VUE_APP_I18N_LOCALE || 'zh'
      }
    },
  },
  created() {
    this._init()
  },
  watch: {
    $route(to, from) {
      this._init()
    },
  },
}
</script>
<style lang="stylus">
.container {
  background-color: #435073;

  .logo {
    height: 80px;
    line-height: 80px;
    padding-left: 8px;
    align-items: center;
    font-weight: bold;

    img {
      max-width: 100%;
      max-height: 64px;
    }
  }

  .welogo {
    padding-right: 8px;
    text-align: right;
  }

  .logos {
    display: flex;

    img {
      max-height: 50px;
      max-width: 50%;
    }
  }

  .menu {
    height: 80px;
    padding: 8px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .menu-item {
      margin-right: 20px;

      a {
        display: inline-block;
        line-height: 22px;
        color: white;
      }

      a.active {
        padding-bottom: 2px;
        border-bottom: 2px solid white;
      }
    }
  }

  .settitle {
    justify-content: center;
    color: #fff;
    font-size: 22px;
  }

  .user-info {
    height: 95px;
    line-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-end;
    padding-right: 8px;

    div {
      color: white;
      font-size: 14px;
    }

    .logout {
      color: red;
      font-weight: bold;
      cursor: pointer;
    }
  }

  .useinfo {
    padding: 10px;
    color: #ffffff;

    .gamename {
      font-size: 18px;
      text-align: center;
      line-height: 24px;
      padding: 0 20px;
    }

    .pageinfo {
      display: flex;
      justify-content: space-between;
      height: 50px;
      align-items: center;
    }

    .teamname {
      text-align: right;
      margin-top: 10px;
      margin-bottom: 5px;
    }

    .logoutm {
      text-align: right;
      color: #f00;
      font-size: 16px;
      font-weight: bold;
      margin-top: 10px;
    }

    .menus {
      text-align: right;

      p {
        margin-bottom: 5px;
      }
    }

    .pagetitle {
      font-weight: bold;
      color: #ff0;
      text-align: center;
      font-size: 18px;
      // letter-spacing: 5px;
    }
  }

  .domainname {
    font-size: 24px;
    color: #fff;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }

  .domainnameM {
    font-size: 18px;
    color: #fff;
    margin-left: 4%;
    line-height: 20px;
  }

  .el-dropdown-link {
    display: inline-block;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #505050;
    background-color: #fff;
    background-image: linear-gradient(to bottom, #fff 0, #e0e0e0 100%);
    background-repeat: repeat-x;
    text-shadow: 0 1px 0 #fff;

    &:hover {
      background-color: #e0e0e0;
      background-position: 0 -15px;
      border-color: #adadad;
    }

    b {
      display: inline-block;
      max-width: 120px;
      font-weight: normal;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .el-dropdown-link-m {
    display: inline-block;
    padding: 3px 5px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: #505050;
    background-color: #fff;
    background-image: linear-gradient(to bottom, #fff 0, #e0e0e0 100%);
    background-repeat: repeat-x;
    text-shadow: 0 1px 0 #fff;
  }
}

.headlogo {
  width: 100%;
  background-color: #435073;

  img {
    max-height: 130px;
    max-width: 100%;
  }
}

.menu-item-phone {
  background-color: #fff;

  li {
    padding: 10px;

    a {
      color: #505050;
    }

    a.active {
      color: #0043ff;
    }
  }
}
</style>
